export function downloadBlob(response) {
  let a = document.createElement('a');
  let blob = new Blob([response.data]);
  let blobUrl = window.URL.createObjectURL(blob, { type: response.data.type });
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = blobUrl;
  a.download = getFilename(response.headers['content-disposition']);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(blobUrl);
}

// Content-Disposition から filename を取り出す。
// filename*=UTF-8''（RFC 6266・日本語ファイル名）を優先し、無ければ filename="..." をフォールバック。
function getFilename(contentDisposition) {
  if (!contentDisposition) return 'download';

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match && utf8Match[1]) {
    return safeDecode(utf8Match[1]);
  }

  const normalMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (normalMatch && normalMatch[1]) {
    return safeDecode(normalMatch[1]);
  }

  return 'download';
}

// decodeURIComponent は生の "%"（例: 100%_pure.pdf）等で URIError を投げるため、
// 失敗時はデコード前の文字列にフォールバックして処理を止めない。
// RFC 5987 の filename* は空白を %20 でエンコードし "+" は plus 記号のままのため、
// "+"→空白の置換は行わない（"C++" 等を壊さない）。
function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
